import { RealTimeMetricEntity } from '@/domain/entities/real-time';
import { IRealTimeRepository } from '@/domain/ports/real-time/repositories';
import { HttpClientAdapter } from '@/graphql/http-client-adapter';
import { REAL_TIME_METRIC } from '@/modules/real-time/graphql';

enum TimePeriod {
  TODAY = 'today',
  THIS_WEEK = 'thisWeek',
  THIS_MONTH = 'thisMonth',
}

export class RealTimeRepository implements IRealTimeRepository {
  async getRealTimeMetric(timePeriod: string): Promise<RealTimeMetricEntity> {
    const timePeriodKey = this.getTimePeriodKey(timePeriod);
    const response = await HttpClientAdapter.query<{
      RealTime_GetMetric: RealTimeMetricEntity;
    }>({
      query: REAL_TIME_METRIC,
      variables: {
        timePeriod: timePeriodKey ?? ('TODAY' as string),
      },
    });
    return {
      ...response.RealTime_GetMetric,
    };
  }

  private getTimePeriodKey(timePeriod: string): string {
    switch (timePeriod) {
      case 'today':
        return 'TODAY';
      case 'thisWeek':
        return 'THIS_WEEK';
      case 'thisMonth':
        return 'THIS_MONTH';
      default:
        return 'TODAY';
    }
  }
}
